import { HubConnectionBuilder } from "@aspnet/signalr";
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Select, FormControl, FormGroup, FormControlLabel, Switch, InputLabel } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { getKey } from "../../helpers/UrlHelper";
import { meetingService } from "../../services/meeting/meeting.service";
import SettingsIcon from "@material-ui/icons/Settings";
import OT from "@opentok/client";
import { ResizeObserver } from "@juggle/resize-observer";
import { clientTypeConstants } from "../../interaction/constants/clientType.constants";
import "./VideoWallStyle.css";
import axios from "axios";
const ro = new ResizeObserver((entries, observer) => {
  entries.forEach((e, index) => {
    if (Math.abs(e.target.clientHeight - (e.target.clientWidth * 0.5625).toFixed(0)) > 3) {
      e.target.style.opacity = 1;
      let toHigh = (e.target.clientHeight / e.target.clientWidth).toFixed(2) > 0.5625;
      if (toHigh) {
        e.target.style.width = "100%";
        e.target.style.height = (e.target.clientWidth * 0.5625).toFixed(0) + "px";
      } else {
        e.target.style.width = (e.target.clientHeight * 1.777777777777778).toFixed(0) + "px";
        e.target.style.height = "100%";
      }
    }
  });
});
const globalStreamList = [];

export default function VonageVideoWall(props) {
  const [showSettings, setShowSettings] = useState(true);
  const [showNametags, setShowNametags] = useState(false);
  const [eventCode, setEventCode] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [eventName, setEventName] = useState(null);
  const [parentEventId, setParentEventId] = useState(null);
  const [name, setName] = useState(null);
  const [screenNo, setScreenNo] = useState(null);
  const [gridClass, setGridClass] = useState("one-row");
  const [maxVids, setMaxVids] = useState(4);
  const [session, setSession] = useState(null);
  const [token, setToken] = useState(null);
  const [hubConnection, setHubConnection] = useState(null);
  const [connecting, setConnecting] = useState(false);
  const [connected, setConnected] = useState(false);
  const [countdown, setCountdown] = useState(null)
  const [reconnectCounter, setReconnectCounter] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [templateId, setTemplateId] = useState(-1);
  const [streams, setStreams] = useState([]);
  const [linkToPage, setLinkToPage] = useState("");
  const onStreamDestroyedRef = useRef();
  const kickPersonFromWallRef = useRef();
  const onConnectionCloseRef = useRef();
  const [activeTemplateContent, setActiveTemplateContent] = useState(null);
  const activeTemplate = templateList.find(t => t.templateId === templateId);
  const activeVideoCount = streams.length;
  const getOrderListIntervalRef = useRef();
  const getOrderListRef = useRef();

  useEffect(() => {
    const { location, match } = props;
    let eventCode = match.params.id;
    const params = new URLSearchParams(location.search);
    const preSetMaxCount = params.get(getKey("max", params));
    const preSetName = params.get(getKey("name", params));
    const preSetScreenNo = params.get(getKey("screenNo", params));
    const preSetTemplate = params.get(getKey("template", params));
    const preSetNametags = params.get(getKey("showNametags", params));
    setEventCode(eventCode);

    if (preSetName) {
      setName(preSetName.toLowerCase());
    }
    else {
      alert("Name missing");
    }
    if (preSetScreenNo && !isNaN(preSetScreenNo)) {
      setScreenNo(preSetScreenNo || 1);
    }
    if (preSetNametags && preSetNametags.toLowerCase() == "true") {
      setShowNametags(true);
    }
    if (preSetTemplate && !isNaN(preSetTemplate)) {
      setTemplateId(parseInt(preSetTemplate));
    }
    if (preSetMaxCount && !isNaN(preSetMaxCount)) {
      setMaxVids(parseInt(preSetMaxCount));
    }
    meetingService.getEventId(eventCode).then(({ eventId, eventName, parentEventId }) => {
      setEventId(eventId);
      setEventName(eventName);
      setParentEventId(parentEventId);
      axios.get(`./api/template/event/${eventId}?includeInherited=true`).then(({ data }) => {
        setTemplateList(data);
      })
    });

  }, []);

  useEffect(() => {
    onStreamDestroyedRef.current = onStreamDestroyed;
    onConnectionCloseRef.current = onConnectionClose;
    kickPersonFromWallRef.current = kickPersonFromWall;
    getOrderListRef.current = getOrderList;
    if (hubConnection) {
      hubConnection.on("onVonageVideoWallHandshake", onVonageVideoWallHandshake);
      hubConnection.on("onGetVideoWallSession", onGetVideoWallSession);
      hubConnection.on("onGetOrderList", onGetOrderList);
    }
    if (session) {
      session.on("streamCreated", onStreamCreated);
    }
    return () => {
      if (hubConnection) {
        hubConnection.off("onVonageVideoWallHandshake", onVonageVideoWallHandshake);
        hubConnection.off("onGetVideoWallSession", onGetVideoWallSession);
        hubConnection.off("onGetOrderList", onGetOrderList);
      }
      if (session) {
        session.off("streamCreated", onStreamCreated);
      }
    }
  });
  useEffect(() => {
    if (activeTemplate && activeTemplate.content)
      setActiveTemplateContent(JSON.parse(activeTemplate.content))
    else setActiveTemplateContent(null);
  }, [activeTemplate]);
  useEffect(() => {
    calculateColumns();
  }, [activeVideoCount]);

  useEffect(() => {
    var newLink = `https://${window.location.host}${window.location.host.includes("localhost") ? "" : "/interaction"}/videowall/${eventCode}?name=${name}&screenno=${screenNo}&max=${maxVids}${templateId > 0 ? `&template=${templateId}` : ''}${showNametags ? `&showNametags=true` : ''}`;
    setLinkToPage(newLink)
  }, [templateId, showNametags, name, maxVids, screenNo])
  useEffect(() => {
    if (showNametags && hubConnection) {

    }
  }, [showNametags]);

  useEffect(() => {
    if (connected == false && connecting == false && hubConnection?.connectionState === 0) {
      tryReconnect();
      var counter = setInterval(() => {
        setCountdown((prevCount) => prevCount + 1);
      }, 1000);
      if (reconnectCounter) clearInterval(reconnectCounter);
      setReconnectCounter(counter);
    } else if (countdown >= 60 && !connected && hubConnection) {
      setCountdown(0);
      setConnecting(false);
      tryReconnect();
    } else if (connected == true && !connecting && hubConnection && hubConnection.connectionState == 1) {
      if (reconnectCounter) clearInterval(reconnectCounter);
      setCountdown(0);
      setReconnectCounter(null);
    }
  }, [connected, connecting, countdown]);
  function tryReconnect() {
    if (!connecting && !connected && hubConnection) {
      connectToHub();
    }
  }
  const connectToHub = () => {
    let hc = hubConnection;
    if (!hc) hc = new HubConnectionBuilder().withUrl("./ihub").build();
    setConnecting(true);
    hc
      .start()
      .then(() => {
        hc.onclose(() => onConnectionCloseRef.current());
        const handshakeObj = {
          eventId: eventId,
          clientType: clientTypeConstants.INTERACTION_VONAGE_VIDEOWALL,
          clientKey: null,
          channel: `${name}_${screenNo}`,
          exhibitorId: null,
          code: null,
          userGuid: null,
          userInfo: null,
        };
        hc.invoke("vonageVideoWallHandshake", handshakeObj);
      })
      .catch(function (e) {
        console.error(e);
      });
    setHubConnection(hc);
  };
  const onConnectionClose = () => {
    setConnected(false);
  }
  function onVonageVideoWallHandshake(response) {
    const { success } = response;
    document.title = response.eventName || "";
    if (!success) {
      setConnected(false);
      return;
    }
    setConnecting(false);
    setConnected(true);
    hubConnection.invoke("getVideoWallSession", eventId, name, screenNo, maxVids);
    hubConnection.invoke("getOrderList", eventId);
    getOrderListIntervalRef.current = setInterval(getOrderListRef.current(), 15000);
  }
  function getOrderList() {
    if (showNametags && hubConnection) {
      hubConnection.invoke("getOrderList", eventId);
    }
  }
  function onGetOrderList(list) {
    setOrderList(list);
  }
  function onGetVideoWallSession(apiKey, sessionId, token) {
    var session = OT.initSession(apiKey, sessionId);
    setSession(session);
    session.connect(token, (error) => {
      if (error) console.error(error);
    });
    setToken(token);
  }
  function calculateColumns() {
    const vids = activeVideoCount;
    if (vids <= 1) {
      setGridClass("one-row-single");
    } else if (vids == 2) {
      setGridClass("one-row");
    } else if (vids > 2 && vids < 5) {
      setGridClass("two-row");
    } else if (vids >= 5 && vids < 10) {
      setGridClass("three-row");
    } else if (vids >= 10 && vids < 13) {
      setGridClass("three-row wide");
    } else if (vids >= 13 && vids < 17) {
      setGridClass("four-row");
    } else if (vids >= 17 && vids < 21) {
      setGridClass("four-row wide");
    } else if (vids >= 21 && vids < 26) {
      setGridClass("five-row");
    } else if (vids >= 26 && vids < 31) {
      setGridClass("five-row wide");
    } else if (vids >= 31 && vids < 37) {
      setGridClass("six-row");
    } else if (vids >= 37 && vids < 43) {
      setGridClass("six-row wide");
    }else if (vids >= 43 && vids < 50) {
      setGridClass("seven-row");
    }
    else {
      setGridClass("seven-row wide");
    }
  }
  function onStreamCreated(event) {
    var targetContainer = "vonage-grid-container";
    var targetOptions = {
      insertMode: "append",
      width: "0%",
      height: "0%",
      showControls: false,
    };
    let newStream = session.subscribe(event.stream, targetContainer, targetOptions); //här
    const streamName = newStream.stream.name;
    newStream.on("destroyed", (event) => { onStreamDestroyedRef.current(event, streamName); });
    addNametag(newStream);
    // speakerDetection(newStream, setSubscriberStartTalking, setSubscriberStopTalking);
    // newStream.element.addEventListener("click", (t) => setFocusedStream(t.currentTarget));
    ro.observe(newStream.element);
    newStream.element.addEventListener("click", () => kickPersonFromWallRef.current(streamName));
    globalStreamList.push(newStream);
    setStreams([...globalStreamList]);
    hubConnection.invoke("videoWallPersonConnected", eventId, name, screenNo, newStream.stream.name);

  }
  function kickPersonFromWall(clientKey) {
    if (hubConnection && hubConnection.connectionState == 1) {
      hubConnection.invoke("kickPersonFromWall", eventId, name, clientKey);
    }
  }
  function onStreamDestroyed(event, clientKey) {
    var sIndex = globalStreamList.indexOf(globalStreamList.find((s) => s.widgetId === event.target.widgetId));
    if (sIndex != -1) {
      globalStreamList.splice(sIndex, 1);
      hubConnection.invoke("videoWallPersonDisconnected", eventId, name, screenNo, clientKey);
      setStreams([...globalStreamList]);
    }
  }
  function addNametag(subscriber) {

    var nametag = document.createElement("div");
    nametag.style.position = "absolute";
    nametag.style.top = "2%";
    nametag.style.right = "0px";
    nametag.style.left = "0px";
    nametag.style.color = "white";
    nametag.style.textAlign = "center";
    nametag.classList.add("person-nametag");
    var order = orderList.find((x) => x.badgeNo == subscriber.stream.name);
    let streamName = order ? order.name : "Guest";
    if (order && order.company) {
      streamName += ", " + order.company;
    }
    var nameText = document.createElement("span");
    nameText.innerText = streamName;
    nameText.style.padding = "4px 10px";
    nameText.style.borderRadius = "5px";
    nameText.style.backgroundColor = "#17171794";
    nametag.appendChild(nameText);
    subscriber.element.appendChild(nametag);
  }
  function saveSettings() {
    if (!hubConnection) {
      connectToHub();
    }
    else {
      hubConnection.invoke("UpdateVideoWallSettings", eventId, name, session.id, screenNo, maxVids);
    }
    setShowSettings(false)
  }
  function selectText(containerid) {
    if (document.selection) { // IE
      var range = document.body.createTextRange();
      range.moveToElementText(document.getElementById(containerid));
      range.select();
    } else if (window.getSelection) {
      var range = document.createRange();
      range.selectNode(document.getElementById(containerid));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
  }
  return (
    <div className={`body${!showNametags ? " hide-nametags" : null}`} style={activeTemplate && !activeTemplate.formattedCss && activeTemplateContent ? { ...activeTemplateContent.main } : null}>
      <div id="vonage-module-wrap" style={{ width: "100vw", height: "100vh", position: "relative" }}>
        {activeTemplate && activeTemplate.formattedCss ?
          <style>{activeTemplate.formattedCss}</style>
          : null}

        <IconButton id="hidden-settings-btn" onClick={() => setShowSettings(true)} style={{ position: "absolute", top: "1%", right: "1%" }}>
          <SettingsIcon />
        </IconButton>
        <Dialog open={showSettings} onClose={() => saveSettings()} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Inställningar - {eventName}</DialogTitle>
          <DialogContent>
            <TextField
              variant="outlined"
              margin="dense"
              id="wallname"
              label="Väggnamn"
              type="text"
              fullWidth
              value={name}
              disabled
              onChange={(e) => {
                setName(e.target.value || '');
              }}
            />
            <TextField
              variant="outlined"
              margin="dense"
              id="wallnumber"
              label="Väggnummer"
              type="number"
              fullWidth
              disabled
              value={screenNo}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setScreenNo(parseInt(e.target.value));
                }
              }}
            />
            <TextField
              autoFocus
              variant="outlined"
              margin="dense"
              id="maxcount"
              label="Max Antal"
              type="number"
              fullWidth
              value={maxVids}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setMaxVids(parseInt(e.target.value));
                }
              }}
            />

            <TextField
              variant="outlined"
              margin="dense"
              id="wallnumber"
              label="Template"
              select
              fullWidth
              value={templateId}
              onChange={(event) => setTemplateId(event.target.value)}
            >
              <MenuItem value={-1} >None</MenuItem>
              {templateList.map(t => {
                return <MenuItem value={t.templateId} key={t.templateId}>{t.name}</MenuItem>
              })}
            </TextField>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value={showNametags}
                  control={<Switch checked={showNametags}
                    onChange={() => setShowNametags(!showNametags)} color="primary" />}
                  label="Visa namnskyltar"
                  labelPlacement="start"

                />
              </FormGroup>
            </FormControl>

            <p style={{ background: "#eee" }} id="linkfield" onClick={(e) => selectText("linkfield")}>{linkToPage}</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={saveSettings} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <div id="vonage-grid-wrap" style={{ display: "flex" }}>
          <div className={gridClass} id={"vonage-grid-container"}></div>
        </div>
      </div>
    </div>
  );
}
